import * as React from 'react';
import { path, pathOr } from 'ramda';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';
import { useFormTracking } from '../../utils/useFormTracking';
import { Textarea } from '../../components/Textarea';

export const TextareaQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answerField, placeholder, title, required, helpText },
    setAnswer,
    answersState,
    setNextStep,
  } = props;

  const isDesktop = useIsDesktop();
  const { trackSubmit, trackChange } = useFormTracking();

  const handleSubmit = React.useCallback(() => {
    setNextStep(answersState);
    trackSubmit({
      isRequired: required,
      value: pathOr('', [answerField, 'value'], answersState),
      field: answerField,
    });
  }, [trackSubmit, answersState, setNextStep, answerField, required]);

  const handleChange = React.useCallback<React.ChangeEventHandler<HTMLTextAreaElement>>(
    e => {
      setAnswer({ answerField, value: e.target.value });
      trackChange();
    },
    [setAnswer, answerField, trackChange],
  );

  const isNextBtnDisabled = required && !path([answerField, 'value'], answersState);

  return (
    <QuestionLayoutContainer
      title={title}
      onSubmit={handleSubmit}
      disableSubmit={isNextBtnDisabled}
      buttonText={props.submitButtonText}
      error={props.error}
      showButtonPreloader={props.showButtonPreloader}
      buttonFullWidth={!isDesktop}
      description={helpText?.text}
    >
      <Textarea
        autoFocus
        placeholder={placeholder || ''}
        onChange={handleChange}
        value={pathOr('', [answerField, 'value'], answersState)}
        rows={4}
      />
    </QuestionLayoutContainer>
  );
};

TextareaQuestionContainer.displayName = 'TextareaQuestionContainer';
